export interface AdviceItem {
  adviceType: string;
  adviceTypeDesc: string;
  adviceDesc: string;
  submitTime: string;
  replyStatus: number;
  replyContent: string;
  replyTime: string;
}

// 回复状态
export enum ReplyStatus {
  NO = 0, // 未回复
  YES = 1, // 已回复
}
